// Palette derived from "Колядники" by Ivakhenko + lapathoniia.top
// Sky teal = base, Star orange = CTA, Chartreuse gold = highlights
export const brand = {
  // Surfaces — painting's dark teal sky/ground
  bg: '#0f2428',
  bgCard: '#142e33',
  bgMuted: '#1a3a3f',
  bgElevated: '#1e4248',

  // CTA — the star/sun gradient
  orange: '#e87030',
  orangeLight: '#f0884a',
  gold: '#f0d040',
  goldMuted: '#a89838',

  // Teal — the sky
  tealLight: '#4ecdc4',
  tealBright: '#6ee7df',

  // Text — warm cream like lantern glow
  cream: '#f4edd4',
  creamMuted: '#c4d8c8',
  creamSubtle: '#8aaa9c',

  // Borders
  border: '#1e4248',
  borderLight: 'rgba(244, 237, 212, 0.09)',
  borderWarm: 'rgba(232, 112, 48, 0.15)',

  // Semantic
  red: '#cc3322',
  accent: '#e87030',
  success: '#4ecdc4',
  error: '#cc3322',
  errorMuted: 'rgba(204, 51, 34, 0.12)',
  warning: '#f0d040',

  // Compat
  green: '#4ecdc4',
  greenDark: '#38b2a8',
  navy: '#0f2428',
  black: '#0a1a1d',
  white: '#f4edd4',
  grey100: '#142e33',
  grey200: '#1a3a3f',
  grey300: '#1e4248',
  grey400: '#6a9a8c',
  grey500: '#b0c8b8',
} as const;

export const space = (n: number) => `${n * 8}px`;

export const fontFamily = "'DM Sans', 'Inter', sans-serif";
